import { getBooleanFromValue } from '@/global/utils/utils'

export default {
  computed: {
    tripConfigEditConfig () {
      return {
        title: this.$t('fleet/vehicle.trip_config'),
        key: 'tripConfig',
        formData: this.formData?.item,
        visible: !!this.showItem?.tabsPermissions?.tripConfig,
        onTabChange: () => {
          this.showMainEditButtons = true
        },
        editUpdate: (event) => {
          const { edit } = event || {}
          this.$set(this.disableTabs, 'canBus', edit)
          this.$set(this.disableTabs, 'readouts', edit)
          this.$set(this.disableTabs, 'documents', edit)
          this.$set(this.disableTabs, 'inspections', edit)
          this.$set(this.disableTabs, 'insurances', edit)
          this.$set(this.disableTabs, 'leasing', edit)
          this.$set(this.disableTabs, 'rangeLimits', edit)
          this.$set(this.disableTabs, 'serviceIntervals', edit)
          this.$set(this.disableTabs, 'serviceHistory', edit)
          this.$set(this.disableTabs, 'comments', edit)
          this.$set(this.disableTabs, 'damages', edit)
        },
        tabContent: [
          {
            title: this.$t('fleet/vehicle.trip_config'),
            component: this.columnsContentComponent,
            rows: [
              {
                disabled: !getBooleanFromValue(this.permissions?.canEdit),
                columnsCount: 3,
                fields: [
                  {
                    key: 'trip_config',
                    label: this.$t('fleet/vehicle.trip_config'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'trip-configs'
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
